import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { PRODUCT_TOP } from "../../constants";
import getProductProps from "../../helpers/get-product-props";
import "swiper/css";
import "swiper/css/navigation";

const TopProducts = ({ data }) => {
  const [queryParameters] = useSearchParams();
  const [showFullDescriptions, setShowFullDescriptions] = useState([]);
  const currentCategory = useSelector(
    (state) => state.dataUploader.currentCategoryData,
  );

  const toggleDescription = (productId) => {
    setShowFullDescriptions((prevState) => {
      const newState = { ...prevState };
      newState[productId] = !newState[productId];
      return newState;
    });
  };

  return (
    <>
      {data.length > 0 ? (
        <div className="top-products-title section-title-wrapper">
          <h2 className="title">Featured Products</h2>
        </div>
      ) : null}

      <div className="top-products-desktop">
        <div className="top-products-container">
          {data.slice(0, 4).map((el, i) => {
            const {
              id,
              brandName,
              title,
              productImage,
              productPrice,
              description,
              currencySymbol,
              brandImage,
            } = el;
            const {
              productFullLink,
              croppedTitle,
              showFullDescription,
              croppedDescription,
            } = getProductProps(
              queryParameters,
              el,
              showFullDescriptions,
              PRODUCT_TOP,
              currentCategory.provider,
            );

            return (
              <div className="row-col" key={id + i}>
                <div className="axil-product product-style-one has-color-pick">
                  <div className="thumbnail">
                    <Link to={`/product/${id}`}>
                      <img src={productImage} alt={title} />
                    </Link>
                    <div className="product-hover-action">
                      <ul className="cart-action">
                        <li className="select-option">
                          <a
                            href={`/product/${id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Get Deal
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="product-content">
                    <div className="inner top-products">
                      {brandImage ? (
                        <img
                          className="product-brand-image"
                          src={brandImage}
                          alt={brandName}
                          width={30}
                          height={30}
                        />
                      ) : null}

                      <h5 className="title">
                        <Link
                          to={`/product/${id}`}
                          className={croppedTitle !== title ? "add-popup" : ""}
                        >
                          {croppedTitle}
                        </Link>
                        {croppedTitle !== title ? (
                          <Link
                            className="title-popup"
                            to={`/product/${id}`}
                          >
                            {title}
                          </Link>
                        ) : null}
                      </h5>

                      <div>
                        {/* <div className="inner">
                          <p className={showFullDescription ? "show-full" : ""}>
                            {showFullDescription
                              ? description
                              : croppedDescription}
                            {description.length > 30 && (
                              <span className="read-more">
                                {showFullDescription ? (
                                  <button onClick={() => toggleDescription(id)}>
                                    Show less
                                  </button>
                                ) : (
                                  <button onClick={() => toggleDescription(id)}>
                                    Show more
                                  </button>
                                )}
                              </span>
                            )}
                          </p>
                        </div> */}

                        <div className="product-price-variant">
                          <span className="price current-price">
                            {`${currencySymbol.length > 1 ? productPrice + " " + currencySymbol : currencySymbol + productPrice}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="top-products-mobile">
        <div className="carousel">
          <Swiper
            navigation={true}
            modules={[Autoplay, Navigation]}
            loop={true}
            // autoplay={{
            //   delay: 5000,
            //   disableOnInteraction: false,
            // }}
            autoplay={false}
            breakpoints={{
              100: {
                spaceBetween: 20,
                slidesPerView: 1,
              },
              768: {
                spaceBetween: 20,
                slidesPerView: 1,
              },
            }}
            className="mySwiper"
          >
            {data.slice(0, 4).map((el, i) => {
              const {
                id,
                brandName,
                title,
                productImage,
                productPrice,
                description,
                currencySymbol,
                brandImage,
              } = el;
              const {
                croppedTitle,
                showFullDescription,
                croppedDescription,
              } = getProductProps(
                queryParameters,
                el,
                showFullDescriptions,
                PRODUCT_TOP,
                currentCategory.provider,
              );

              return (
                <SwiperSlide key={id + i} className="slide slide-item">
                  <div className="top-products-slide-card">
                    <div className="axil-product product-style-one has-color-pick">
                      <div className="thumbnail">
                        <Link to={`/product/${id}`}>
                          <img src={productImage} alt={title} />
                        </Link>
                        <ul className="cart-action">
                          <li className="select-option">
                            <Link to={`/product/${id}`}>
                              Get Deal
                            </Link>
                          </li>
                        </ul>
                      </div>

                      <div className="product-content">
                        <div className="inner">
                          {brandImage ? (
                            <img
                              className="product-brand-image"
                              src={brandImage}
                              alt={brandName}
                              width={90}
                              height={30}
                            />
                          ) : null}

                          <h5 className="title" title={title}>
                            <Link to={`/product/${id}`}>
                              {croppedTitle}
                            </Link>
                          </h5>

                          <div>
                            {/* <div className="inner">
                              <p className={showFullDescription ? "show-full" : ""}>
                                {showFullDescription
                                  ? description
                                  : croppedDescription}
                                {description.length > 110 && (
                                  <span className="read-more">
                                    {showFullDescription ? (
                                      <button
                                        onClick={() => toggleDescription(id)}
                                      >
                                        Show less
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => toggleDescription(id)}
                                      >
                                        Show more
                                      </button>
                                    )}
                                  </span>
                                )}
                              </p>
                            </div> */}

                            <div className="product-price-variant">
                              <span className="price current-price">
                                {`${currencySymbol.length > 1 ? productPrice + " " + currencySymbol : currencySymbol + productPrice}`}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default TopProducts;
